"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allFrameworks = exports.detectFramework = void 0;
const frameworks_json_1 = __importDefault(require("./constants/frameworks.json"));
const custom_frameworks_1 = require("./constants/custom-frameworks");
const detectFramework = (packageJson, isDocker = false, files = []) => {
    if (isDocker)
        return custom_frameworks_1.dockerFramework;
    if (packageJson) {
        const detectFramework = frameworks_json_1.default.find((rx) => {
            if (rx.detector) {
                const regex = new RegExp(rx.detector, "gm");
                return regex.test(JSON.stringify(packageJson));
            }
            return false;
        });
        if (detectFramework)
            return detectFramework;
    }
    if (files.includes("composer.json") &&
        ((files.includes("artisan") &&
            files.some((file) => file.endsWith(".php"))) ||
            files.includes("app/Http/Controllers"))) {
        return custom_frameworks_1.laravelFramework;
    }
    if (files.includes("go.mod") || files.includes("main.go")) {
        return custom_frameworks_1.golangFramework;
    }
    if (files.includes("requirements.txt") ||
        files.includes("setup.py") ||
        files.includes("main.py") ||
        files.includes("Pipfile") ||
        files.some((file) => file.endsWith(".py"))) {
        return custom_frameworks_1.pythonFramework;
    }
    return frameworks_json_1.default.find((framework) => framework.slug === "nodejs");
};
exports.detectFramework = detectFramework;
const allFrameworks = frameworks_json_1.default.map((framework) => {
    return {
        name: framework.name,
        slug: framework.slug,
        logo: framework.logo,
        description: framework.description,
        settings: {
            installCommand: framework.settings.installCommand,
            startCommand: framework.settings.startCommand,
            buildCommand: framework.settings.buildCommand,
            outputDirectory: framework.settings.outputDirectory,
        },
        envPrefix: framework.envPrefix,
        type: framework.type,
    };
});
exports.allFrameworks = allFrameworks;
allFrameworks.push(custom_frameworks_1.dockerFramework);
allFrameworks.push(custom_frameworks_1.laravelFramework);
allFrameworks.push(custom_frameworks_1.golangFramework);
allFrameworks.push(custom_frameworks_1.pythonFramework);
